import "./template-bootstrap";
import { isDemoAuthenticated, isValidEmail, LOGIN_PATH, setDemoEmail } from "./auth-shared";

if (isDemoAuthenticated()) {
  window.location.replace("./profile.html");
}

const form = document.getElementById("emailOtpLoginForm") as HTMLFormElement | null;
const emailInput = document.getElementById("emailAddress") as HTMLInputElement | null;
const emailField = document.getElementById("emailField") as HTMLElement | null;
const emailError = document.getElementById("emailError") as HTMLElement | null;
const validationBanner = document.getElementById("validationBanner") as HTMLElement | null;

function setEmailInvalid(invalid: boolean, message?: string): void {
  if (emailField) {
    if (invalid) emailField.setAttribute("invalid", "");
    else emailField.removeAttribute("invalid");
  }
  if (emailError) {
    emailError.textContent = message ?? "";
    emailError.hidden = !invalid;
  }
  if (emailInput) emailInput.setAttribute("aria-invalid", invalid ? "true" : "false");
}

form?.addEventListener("submit", (event) => {
  event.preventDefault();
  if (validationBanner) validationBanner.hidden = true;

  const email = emailInput?.value ?? "";
  if (!isValidEmail(email)) {
    setEmailInvalid(true, "Enter a valid email address.");
    if (validationBanner) validationBanner.hidden = false;
    emailInput?.focus();
    return;
  }

  setEmailInvalid(false);
  setDemoEmail(email);
  window.location.href = "./verify-otp.html";
});

emailInput?.addEventListener("input", () => {
  if (emailField?.hasAttribute("invalid")) setEmailInvalid(false);
});

document.getElementById("passkeySignInButton")?.addEventListener("click", () => {
  const banner = document.getElementById("passkeyErrorBanner") as HTMLElement | null;
  const message = document.getElementById("passkeyErrorMessage");
  if (banner && message) {
    message.textContent = "Passkey sign-in is not wired up in this demo.";
    banner.hidden = false;
  }
});
